import React from 'react'
import { tablet } from "@styles/mixins";
import styled, { css } from "styled-components";
import { useAuthTemplateContext } from "../context";

export default function AuthFooter() {
    const { footer } = useAuthTemplateContext()

    if (!footer)
        return null

    return (
        <FooterWrapper>
            {footer}
        </FooterWrapper>
    )
}

const FooterWrapper = styled.div`
    margin: 0 auto;
    max-width: 200px;
    text-align: center;

    ${tablet(css`
        margin-bottom: -20px;
    `)}
`